import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { SuccessCheckmark } from "../../components/Checkmark";
import { FailureCheckmark } from "../../components/FailureCircle";
import { COLORS } from "../../theme/theme-options";

const OAuthSetupResultPage: React.FC<{ result: "success" | "failed" }> = ({ result }) => {
  const isSuccess = result === "success";

  return (
    <Box
      sx={{
        minHeight: "100%",
        display: "grid",
        placeItems: "center",
        position: "relative",
        overflow: "hidden",
        background:
          "radial-gradient(1000px 400px at 20% -10%, rgba(56,189,248,0.14), transparent 70%), radial-gradient(900px 320px at 80% 110%, rgba(124,58,237,0.12), transparent 70%)",
        p: 2,
      }}
    >
      <Card
        variant="glass"
        sx={{
          margin: "0 auto",
          width: "100%",
          maxWidth: 560,
          p: 3,
          border: `1px solid ${alpha(COLORS.primary[400], 0.25)}`,
          boxShadow: "0 16px 48px rgba(2, 8, 23, 0.45)",
        }}
      >
        <Stack spacing={2.2} alignItems="center" justifyContent="center">
          <Box textAlign="center">
            <Typography sx={{ fontSize: 26, fontWeight: 800, color: COLORS.grey[100] }}>
              OAuth Setup
            </Typography>
          </Box>

          {isSuccess && (
            <Stack spacing={2.2} alignItems="center">
              <SuccessCheckmark />
              <Typography sx={{ fontSize: 22, fontWeight: 700, color: COLORS.success[100] }}>
                Connection completed
              </Typography>
              <Button
                href="/config/tool-integrations"
                variant="outlined"
                startIcon={<ArrowBackRoundedIcon fontSize="small" />}
              >
                Back to integrations
              </Button>
            </Stack>
          )}

          {!isSuccess && (
            <Stack spacing={2.2} alignItems="center">
              <FailureCheckmark />
              <Typography sx={{ fontSize: 22, fontWeight: 700, color: COLORS.error[400] }}>
                Connection failed
              </Typography>
              <Typography sx={{ color: COLORS.grey[500], textAlign: "center" }}>
                Something went wrong during the OAuth setup. Please try again.
              </Typography>
              <Button
                href="/config/tool-integrations"
                variant="outlined"
                startIcon={<ArrowBackRoundedIcon fontSize="small" />}
              >
                Back to integrations
              </Button>
            </Stack>
          )}
        </Stack>
      </Card>
    </Box>
  );
};

export default OAuthSetupResultPage;
